import { render, staticRenderFns } from "./ToRevisionOriginalDocuments.vue?vue&type=template&id=bd3e5f2a&scoped=true"
import script from "./ToRevisionOriginalDocuments.vue?vue&type=script&lang=js"
export * from "./ToRevisionOriginalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3e5f2a",
  null
  
)

export default component.exports